<template>
    <div class="facebook-customer-chat" ref="fbChat">
    </div>
</template>
<script>
    export default {
        name: "facebook-chat-widget",
        data() {
            return {
                loaded: false,
                rendered: false,
                shown: false
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {
                // 0. Guard
                if (this.loaded || !this.enabled || !this.pageId)
                    return;

                // 1. FB Customer Chat Plugin Setup
                let vm = this;
                window.fbAsyncInit = function () {
                    FB.init({
                        xfbml: true,
                        version: 'v3.2'
                    });
                    vm.onLoaded();
                };
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));

                this.loaded = true;
            },
            onLoaded() {
                this.render();
                this.shown = true;
            },
            render() {
                // 0. Guard
                if (this.rendered || !this.pageId || !this.enabled)
                    return;

                const el = document.createElement('div');
                el.setAttribute('class', 'fb-customerchat');
                el.setAttribute('page_id', this.config.pageId);
                el.setAttribute('theme_color', this.config.themeColor);
                el.setAttribute('logged_in_greeting', this.config.greeting);
                el.setAttribute('logged_out_greeting', this.config.greeting);
                this.$refs.fbChat.appendChild(el);
                this.rendered = true;
            },
            destroy() {
                // 0. Guard
                if (!this.rendered)
                    return;

                let oldChatDialog = document.getElementsByClassName("fb_dialog");
                let oldChatParent = document.getElementsByClassName("fb-customerchat");
                oldChatDialog[0] && oldChatDialog[0].parentNode.removeChild(oldChatDialog[0]);
                oldChatParent[0] && oldChatParent[0].parentNode.removeChild(oldChatParent[0]);
                this.rendered = false;
            },
            refresh() {
                if (!this.loaded) {
                    this.load();
                } else {
                    if (this.rendered)
                        this.destroy();
                    if(this.pageId) {
                        this.render();
                        FB.XFBML.parse();
                    }
                }
            },
            onEnabled() {
                if (!this.loaded) {
                    this.load();
                } else if (!this.shown) {
                    FB.CustomerChat.show(false);
                    this.shown = true;
                }
            },
            onDisabled() {
                if (this.shown) {
                    FB.CustomerChat.hide();
                    this.shown = false;
                }
            }
        },
        computed: {
            configActive() {
              return this.$store.state.dismissConfigOverlay
            },
            config() {
                return ab.config.liveChat.platforms.filter((platform) => platform.name === 'Facebook')[0].config;
            },
            enabled() {
                return ab.config.liveChat.enabled && ab.config.liveChat.selectedPlatform === 'Facebook';
            },
            pageId() {
                return this.config.pageId;
            },
            themeColor() {
                return this.config.themeColor;
            },
            greeting() {
                return this.config.greeting;
            }
        },
        watch: {
            configActive(active) {
              if(!this.rendered) {
                return
              }
              /** Sorry, but jQuery is sometimes more practical */
              if(active) {
                $("#fb-root").css('visibility', 'hidden')
                $(".fb-customerchat iframe").css('visibility', 'hidden')
              } else {
                $("#fb-root").css('visibility', 'visible')
                $(".fb-customerchat iframe").css('visibility', 'visible')
              }
            },
            enabled(enabled) {
                if (enabled)
                    this.onEnabled();
                else
                    this.onDisabled();
            },
            pageId() {
                this.refresh();
            },
            themeColor() {
                this.refresh();
            },
            greeting() {
                this.refresh();
            }
        }
    }
</script>
